import React from 'react';
import styles from './MapVignette.module.scss';

const MapVignette: React.FC = () => <div className={styles.vignette} />;

export default MapVignette;
